import { UploadOutlined } from "@ant-design/icons"
import {
  Button,
  Descriptions,
  Divider,
  Drawer,
  Form,
  Space,
  Typography,
  Upload,
  Input,
  message,
  Popconfirm,
} from "antd"
import { doc, updateDoc } from "firebase/firestore"
import React, { useState } from "react"
import { db, storage } from "../../../firebase/config"
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"
import moment from "moment/moment"

const { Dragger } = Upload
const { Text, Link } = Typography
const { TextArea } = Input

export default function TechnicalReqDetails({ priceData }) {
  const [open, setOpen] = useState(false)
  //technical page file
  const [uploadedFile, setUploadedFile] = useState(null)
  const [buttonLoading, setButtonLoading] = useState(false)
  const [denyComment, setDenyComment] = useState("")

  // upload and accept technical
  const uploadAndAcceptTechnical = async () => {
    setButtonLoading(true)
    const docref = doc(db, "priceCalculation", priceData.id)

    try {
      const file = uploadedFile

      if (!file) {
        message.error("Please select a file to upload.")
        return // Exit if no file is selected
      }

      const filePath = `prices/${priceData.id}/${file.name}`
      const storageRef = ref(storage, filePath)
      await uploadBytesResumable(storageRef, file)

      // Use the created reference to get the download URL
      const downloadURL = await getDownloadURL(ref(storage, filePath))
      await updateDoc(docref, {
        technicalPage: downloadURL,
        hasTechincalPage: 2,
      })

      message.success("Technical Added!")
      setOpen(false)
      form.resetFields()
    } catch (error) {
      console.error("Error:", error)
      message.error(error.message)
    } finally {
      setButtonLoading(false)
    }
  }

  const props = {
    name: "file",
    multiple: false,
    beforeUpload: (file) => {
      setUploadedFile(file)
      return false // return false to prevent automatic upload
    },
    onDrop(e) {
      console.log("Dropped files", e.dataTransfer.files)
    },
  }
  //init form
  const [form] = Form.useForm()

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
    setUploadedFile(null)
    setButtonLoading(false)
  }

  const onFinish = (values) => {
    uploadAndAcceptTechnical()
  }
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo)
  }

  //does it has previous technical pages?
  const doesPreviousExist = () => {
    if (priceData.updateForTechnical) {
      return (
        <>
          <Divider>Previous technical pages</Divider>
          {priceData.previousTechnicalPages.map((item, index) => (
            <div key={index}>
              <Space split={<Divider type="vertical" />}>
                <Link href={item.link} target="_blank">
                  Link
                </Link>
                <Text>{moment(item.date).format("MMMM Do YYYY, h:mm:ss a")}</Text>
              </Space>
            </div>
          ))}
          <Divider>Comment from user</Divider>
          <TextArea readOnly rows={8} value={priceData.technicalPageComment} />
        </>
      )
    }
  }

  const confirm = (e) => {
    console.log(e)
    denyAndSendBack()
  }

  //deny popover content
  const denyContent = () => {
    return (
      <div style={{ width: 350 }}>
        <Text>Comment on sending back</Text>
        <TextArea rows={5} onChange={(event) => setDenyComment(event.target.value)} />
      </div>
    )
  }

  //deny and send back
  const denyAndSendBack = async () => {
    const docref = doc(db, "priceCalculation", priceData.id)

    try {
      await updateDoc(docref, {
        denyComment: denyComment,
        hasTechincalPage: 3,
      }).then(() => {
        message.success("Sent!")
      })
    } catch (err) {
      console.log(err)
      message.error("Somethin went wrong, check logs")
    } finally {
      onClose()
    }
  }

  const translateKeysDesc = (value) => {
    switch (value) {
      case "relief":
        return "Relief"
      case "goldOrSilver":
        return "Gold / Silver"
      case "cmykColors":
        return "CMYK Colors"
      case "coveringWCount":
        return "Covering White Count"
      case "varnishType":
        return "Varnish Type"
      case "pantoneColors":
        return "Pantone Colors"
      case "varnishUse":
        return "Varnish being used"
      default:
      // code block
    }
  }

  return (
    <>
      <Button size="small" type="primary" onClick={showDrawer}>
        Show
      </Button>
      <Drawer title="Product details" placement="left" onClose={onClose} open={open}>
        <Divider>Technical page comments</Divider>
        <TextArea readOnly rows={5} value={priceData.technicalComment} />
        <Divider>Print details</Divider>

        <Descriptions size="small" column={1}>
          {Object.entries(priceData.print)
            .filter(
              ([key, value]) =>
                value !== null &&
                value !== 0 &&
                value !== "none" &&
                value !== "No" &&
                key !== "reliefId" &&
                key !== "varnishId" &&
                key !== "cmykPercent" &&
                key !== "goldOrSilverPercent" &&
                key !== "coveringWPercent" &&
                key !== "varnishPercent" &&
                key !== "pantonePercent" &&
                key !== "varnishUse",
            )
            .map(([key, value]) => (
              <Descriptions.Item label={translateKeysDesc(key)} key={key}>
                {value}
              </Descriptions.Item>
            ))}
        </Descriptions>

        <Divider>Other details</Divider>
        <Descriptions size="small" column={1}>
          <Descriptions.Item label="Label Width">{priceData.labelWidth}</Descriptions.Item>
          <Descriptions.Item label="Label Height">{priceData.labelHeight}</Descriptions.Item>
          <Descriptions.Item label="Manager">{priceData.userEmail}</Descriptions.Item>
          <Descriptions.Item label="Knife Code">
            {priceData.knifeCode && priceData.knifeCode === "none"
              ? "new knife"
              : priceData.knifeCode}
          </Descriptions.Item>
          <Descriptions.Item label="Format Width">{priceData.formatWidth}</Descriptions.Item>
          <Descriptions.Item label="Material">{priceData.material}</Descriptions.Item>
        </Descriptions>

        {doesPreviousExist()}

        <Divider>Add Technical</Divider>
        <Form
          form={form}
          initialValues={{
            remember: true,
          }}
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          style={{ width: "100%" }}>
          <Form.Item
            label="Technical Page"
            name="technicalPage"
            rules={[
              {
                required: true,
                message: "Please input your field!",
              },
            ]}>
            <Dragger {...props}>
              <UploadOutlined />
              <Text>Please click or drag to upload</Text>
            </Dragger>
          </Form.Item>
          <Form.Item>
            <Button block type="primary" loading={buttonLoading} htmlType="submit">
              Upload & Approve
            </Button>
          </Form.Item>
          <Form.Item>
            <Popconfirm
              title="Deny & Send back?"
              description={denyContent}
              onConfirm={confirm}
              placement="right"
              okText="Yes"
              cancelText="No">
              <Button block danger loading={buttonLoading}>
                Deny & Send Back
              </Button>
            </Popconfirm>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  )
}
